<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" [text]="'core.backButton' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ stationName }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="openStationSelection()" [attr.aria-label]="'departure-monitor.stations' | translate">
        <ion-icon slot="icon-only" name="list"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (departures?.length) {
    <table>
      <thead>
        <tr>
          <th>{{ 'departure-monitor.time' | translate }}</th>
          <th>{{ 'departure-monitor.line' | translate }}</th>
          <th>{{ 'departure-monitor.direction' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (departure of departures; track departure) {
          <tr>
            <td class="time">
              {{ departure.date_time | date:'HH:mm' }} <br />
              @if (departure.delay !== 0 && departure.delay !== null) {
                <div class="delay">
                  <img src='assets/departure/delay.svg' /> (+{{ departure.delay }})
                </div>
              }
              @if (departure.delay === null) {
                <div class="delay">
                  <img src='assets/departure/delay.svg' /> {{ 'departure-monitor.cancelled' | translate }}
                </div>
              }
            </td>
            <td class="line">
              <span class="line"><img class="type" src="assets/departure/{{departure.transport_type}}.svg" /></span>
              <span class="line">{{ departure.line }}</span>
            </td>
            <td>
              <div>{{ departure.direction }}</div>
              <div class="route">{{ departure.line_description }}</div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <ion-item>
      <ion-label class="ion-text-wrap">
        <p>
          {{ 'departure-monitor.timetableNotAvailable' | translate }}
        </p>
      </ion-label>
    </ion-item>
  }
</ion-content>
